<template lang="pug">
.consulAddDialog
    el-form(label-position='right', :rules='rules', label-width='130px', :model='addform',ref="addform")
        el-form-item(label='议题666编号:', prop='consultNumber')
            el-input(size='mini', style='width:90.5%', placeholder='请输入', v-model='addform.consultNumber' disabled) 
        el-form-item(label='镇/街道:', prop='streetName')
            //- el-select(v-model="addform.streetName" placeholder="请选择" disabled style='width:40%')
            //-     el-option(v-for="item in streetList",:key="item.value",:label="item.label",:value="item.value")
            el-input(size='mini', style='width:40%', placeholder='请输入', v-model='addform.streetName' disabled)
            <span style="margin:0 25px;">村/社区</span>
            el-input(size='mini', style='width:40%', placeholder='请输入', v-model='addform.communityId' disabled)
        //- el-form-item(label='村/社区:', prop='communityId')
        //-     el-select(v-model="addform.communityId" placeholder="请选择" disabled)
        //-         el-option(v-for="item in cunList",:key="item.value",:label="item.label",:value="item.value")
        //- el-form-item(label='议题名称:', prop='consultName')
        //-     el-input(size='mini', style='width:50%', placeholder='请输入', v-model='addform.consultName' disabled)
        el-form-item(label='议题内容:', prop='content')
            el-input(size='mini', style='width:90.5%', placeholder='请输入', v-model='addform.content', type="textarea" disabled) 
        el-form-item(label='议题类型:')
            el-select(v-model="addform.consultTypeName" placeholder="请选择" disabled style='width:90.5%')
                el-option(v-for="item in ytlxtList",:key="item.id",:label="item.consultName",:value="item.id") 
        el-form-item(label='议题来源:', prop='issueSource')
            el-select(v-model="addform.issueSource" placeholder="请选择"  disabled style='width:90.5%')
                el-option(v-for="item in xsytList",:key="item.value",:label="item.label",:value="item.value")
        el-form-item(label='议题层级:', prop='bargainingLevel')
            el-select(v-model="addform.bargainingLevel" placeholder="请选择"  disabled style='width:90.5%')
                el-option(v-for="item in xszjList",:key="item.value",:label="item.label",:value="item.value")
        el-form-item(label='协商内容:', prop='negotiationContent')
            el-input(size='mini', style='width:90.5%', placeholder='请输入', v-model='addform.negotiationContent', type="textarea" disabled) 
        el-form-item(label='处理方式如何协调:', prop='coordinateMethod')
            el-input(size='mini', style='width:90.5%', placeholder='请输入', v-model='addform.coordinateMethod', type="textarea" disabled) 
       
        el-form-item(label='利益相关方:',v-if="this.addform.consultSure == '0'")
            el-button(size='mini',type="success",@click="addPersonOpt" disabled) 添加
            el-table(ref="multipleTable",:data="tableData1",tooltip-effect="dark",style="width: 90.5%")
                //- el-table-column(type="selection",width="55")
                el-table-column(type="index",width="55",label="序号") 
                el-table-column(prop="name",label="姓名",width="120")
                el-table-column(prop="sex",label="性别",width="120")
                    template(scope="scope")
                        span(v-if="scope.row.sex == 0") 男
                        span(v-if="scope.row.sex == 1") 女
                el-table-column(prop="age",label="年龄",width="120")
                el-table-column(prop="phone",label="手机号码",width="120")
                el-table-column(prop="remarks",label="备注",width="120")
        //- el-form-item(label='参与协商人员:',v-if="this.addform.consultSure == '0'")
        //-     el-button(size='mini',type="success",@click="addPersonInfo" disabled) 添加
        //-     el-table(ref="multipleTable",:data="tableData",tooltip-effect="dark",style="width: 100%")
        //-         //- el-table-column(type="selection",width="55")
        //-         el-table-column(type="index",width="55",label="序号") 
        //-         el-table-column(prop="name",label="姓名",width="120")
        //-         el-table-column(prop="sex",label="性别",width="120")
        //-         el-table-column(prop="phone",label="手机号",width="120")
        //-         el-table-column(prop="parentPersonTypeName",label="类别",width="120")
        el-form-item(label='确定方式:', prop='confirmateMethod')
            el-select(v-model="addform.confirmateMethod" placeholder="请选择" style='width:90.5%' disabled)
                el-option(v-for="item in sureList",:key="item.value",:label="item.label",:value="item.value")
        el-form-item(label='议题确定:', )
          el-radio(v-model="addform.consultSure" label="0" disabled) 是
          el-radio(v-model="addform.consultSure" label="1" disabled) 否
        el-form-item(v-if="this.addform.consultSure == '0'")
            el-radio(v-model="addform.approvalStatus" label="0" disabled) 交办
            el-radio(v-model="addform.approvalStatus" label="9" disabled) 督办
        el-form-item(v-if="this.addform.consultSure == '1'")
            el-radio(v-model="addform.approvalStatus" label="14" disabled) 暂不协商
            el-radio(v-model="addform.approvalStatus" label="15" disabled) 条件不成熟
        el-form-item(label='原因:')
            el-input(size='mini', style='width:50%', placeholder='请输入', v-model='addform.approvalOpinion', type="textarea",disabled)

    .boontbtn
        //- el-button(type='primary', size='small', style='margin: 0 30px', @click='saveadddata11') 保存
        el-button(type='info', size='small', @click='closeDialog') 关闭

    el-dialog(append-to-body='', title='添加人员类别', :visible.sync='checkpeopType', width='900px')
        peopleTypeDialog(@func="choosePeopleTypeFunc", :isshow="checkpeopType",:fatherdata="addformTypeArr")  

    el-dialog(append-to-body='', title='添加人员', :visible.sync='checkpeop', width='900px')
        peopleDialog(@func="choosePeopleFunc",:choosedata="checkpeopData",:personTypeF="checkpeopTypeData",:isshow="checkpeop")  
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import peopleDialog from "./addPeopleDialog.vue";
import peopleTypeDialog from "./peopleTypeDialog.vue";
import editor_option from "../../../../utils/editorOption.js";
import request from "../../../../utils/request.js";
import { getConsulTYpePersion } from "@/api/http.js";
import { post } from "@/api/requrestHttp";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewAdd",
  props: ["rowid", "show"],
  components: { quillEditor, peopleDialog, peopleTypeDialog },
  data() {
    return {
      id: this.rowid,
      addform: {
        communityId: "",
        consultName: "",
        content: "",
        issueSource: "",
        consultType: "",
        bargainingLevel: "",
        consultSure: ""
      },
      reportSourceType: {
        1: "平台自建",
        2: "居民上报",
        3: "组织上报",
        4: "专家调研",
        5: "发函征集型"
      },
       tableData: [
        ],
      streetList: [
        {
          value: '1',
          label: '广陵街道'
        }
      ],
      cunList: [
        {
          value: '2',
          label: '浔河社区'
        },
        {
          value: '20',
          label: '石街社区'
        }
      ],
      value: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      radio: '',
      radio1: '',
      xsytList: [
        {
        value: '1',
        label: '党小组、村(居)民组会议'
        },
        {
        value: '2',
        label: '群众通过电话或口头等方式'
        },
        {
        value: '3',
        label: '群众通过微信、QQ等方式提出'
        },
        {
        value: '4',
        label: '党员议事日'
        },
        {
        value: '5',
        label: '意见箱'
        },
        {
        value: '6',
        label: '包组干部收集到群众的需求'
        },
        {
        value: '7',
        label: '落实上级党委政府工作安排'
        },
        {
        value: '8',
        label: '其他'
        }
      ],
      ytlxtList: [
        
      ],
      xszjList: [
        {
        value: '1',
        label: '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项'
        },
        {
        value: '2',
        label: '涉及1个村以上"两委"成员包组范围内1村(居)民组事项'
        },
        {
        value: '3',
        label: '涉及与本镇内1个村以上范围事项'
        },
        {
        value: '4',
        label: '涉及本镇以外其他镇的协商事项'
        },
      ],
      sureList: [
        {
        value: '0',
        label: '村"两委"会'
        },
        {
        value: '1',
        label: '扩大会'
        },
        {
        value: '2',
        label: '党员议事会'
        },
      ],
      addformTypeArr: [],
      searchTypes1: [],
      searchTypes2: [],
      selectAreas: [],
      selectOrgs1: [],
      selectOrgs2: [],
      fileList: [],
      rules: {
        consultType: [{ required: true, message: "请选专业", trigger: "blur" }],
        consultName: [
          { required: true, message: "请输入议题名称", trigger: "blur" }
        ],
        reportSource: [
          { required: true, message: "请选择议题来源", trigger: "change" }
        ],
        addressId: [
          { required: true, message: "请选择召开地点", trigger: "change" }
        ],
        keyWord: [{ required: true, message: "请输入关键词", trigger: "blur" }],
        holdingTime: [
          { required: true, message: "请选择召开时间", trigger: "blur" }
        ],
        moderator: [
          { required: true, message: "请输入主持人", trigger: "blur" }
        ],
        link: [{ required: true, message: "请输入视频链接", trigger: "blur" }],
        userName: [
          { required: true, message: "请输入访问用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入访问密码", trigger: "blur" }
        ],
        publishPlatform: [
          { required: true, message: "请输入上架平台", trigger: "change" }
        ]
      },
      // 富文本配置
      editorOption: editor_option.editorOption,
      checkpeop: false,
      checkpeopData: [],
      checkpeopTypeData: "",
      checkpeopFlag: "0",
      numliyi: 1,
      numOther: 1,
      uploadUrl: request.defaults.baseURL + "/admin/consul/info/uplodfiles",

      personType: "1",
      checkpeopType: false,
      persons: [],
      tableData1: [],
      tableList: [],
    };
  },
  methods: {
    // 查看接口
    getFindConsultById() {
      this.tableData = [];
      this.tableData1 = [];
      console.log(this.id)
      post("/admin/consult/info/findConsultById",{
        id: this.id
      }).then(res => {
        console.log(res)
        this.addform = res.content;
        if(res.content.handleStatus == 0){
          this.$set(this.addform,'approvalStatus','0')
        }
        if(res.content.handleStatus == 1){
          this.$set(this.addform,'approvalStatus','9')
        }
        if(res.content.handleStatus == 2){
          this.$set(this.addform,'approvalStatus','14')
        }
        if(res.content.handleStatus == 3){
          this.$set(this.addform,'approvalStatus','15')
        }
        console.log(this.addform.approvalStatus)
        if(this.addform.communityId == 2) {
          this.addform.communityId = '浔河社区'
        }
        if(this.addform.communityId == 20) {
          this.addform.communityId = '石街社区'
        }
        res.content.persons.forEach(item => {
          if(item.type == '0') {
            this.tableData.push(item)
          }else if(item.type == '1') {
            this.tableData1.push(item)
          }
        })
      })
    },
    saveadddata11() {
      // this.persons = [];
      // this.tableData = [];
      // this.tableData1 = [];
      console.log(this.tableData)
      console.log(this.tableData1)
      if(this.addform.approvalStatus == 0){
        this.$set(this.addform,'handleStatus',0)
      }
      if(this.addform.approvalStatus == 9){
        this.$set(this.addform,'handleStatus',1)
      }
      if(this.addform.approvalStatus == 14){
        this.$set(this.addform,'handleStatus',2)
      }
      if(this.addform.approvalStatus == 15){
        this.$set(this.addform,'handleStatus',3)
      }
      console.log(this.addform)

      this.tableData.forEach(item => {
         console.log(item.id)
         var person = {};
         this.person = {"personId": item.id + "","type":"0"}
         console.log(this.person)
         this.persons.push(this.person)
      })
      this.tableData1.forEach(item => {
        this.person ={"name":item.name,"sex":item.sex,"age":item.age,"phone":item.phone,"remarks":item.remarks,"type":"1"}
        this.persons.push(this.person)
      })
      console.log(this.persons)
      post("/admin/consult/info/insertConsult",{
        ...this.addform,
        persons: this.persons
      }).then(res => {
        console.log(res)
        this.closeDialog();
      })
    },
    addPersonInfo() {
      console.log('addPersonInfo')
      this.checkpeopType = true;
    },
    addPersonOpt() {
      console.log('addPersonOpt')
      this.checkpeop = true;
    },
    // 类别
    // getFindConsultList() {
    //   let fd = new FormData();
    //   post("/admin/consulType/info/findConsultTypeList",{
        
    //   }).then(res => {
    //     console.log(res)
    //     console.log('0000')
    //     // this.ytlxtList = 
    //   })
    // },
    async getFindConsultList() {
      let fd = new FormData();
      fd.append("token", token);
      fd.append("pageNo", 1);
      fd.append("pageSize", 100);
      let params = '{"status":""}';
      fd.append("findConsultType", params);
      var res = await request({
        url: "/admin/consulType/info/findConsultTypeList",
        method: "POST",
        data: fd
      });
      console.log(res.content.list)
      if (res.code == 200) {
        this.ytlxtList = res.content.list;
      } else {
        console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    consultTypeChange(e) {
      //   console.log(e);

      this.$set(this.addform, "consultCut", "");
      this.getTypes(e);
    },
    //获取条件查询的议题分类
    async getTypes(selVal) {
      let fd = new FormData();
      fd.append("token", token);
      //获取父类
      if (selVal == "") {
        let params = JSON.stringify({ parentId: 0 });
        fd.append("consultType", params);
        var res = await request({
          url: "/admin/consulType/info/findConsultType",
          method: "POST",
          data: fd
        });
        var temp = {};
        if (res.content && res.content.length > 0) {
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.consultName };
            this.searchTypes1.push(temp);
          });
        }
      } else {
        fd.append("pageNo", 1);
        fd.append("pageSize", 20);
        let params = JSON.stringify({ parentId: selVal });
        fd.append("findConsultType", params);
        // console.log(params)
        var res = await request({
          url: "/admin/consulType/info/findConsultTypeList",
          method: "POST",
          data: fd
        });
        this.searchTypes2 = [];
        var temp = {};
        if (res.code == 200 && res.content.count > 0) {
          res.content.list.forEach(item => {
            temp = {
              id: item.id,
              value: item.consultName,
              label: item.consultName
            };
            this.searchTypes2.push(temp);
          });
        }
      }
    },
    orgPidChange(e) {
      this.$set(this.addform, "orgId", "");
      this.getOrg(e);
    },
    //获取所属组织
    async getOrg(selVal) {
      let fd = new FormData();
      fd.append("token", token);
      //获取父类
      if (selVal == "") {
        fd.append("parentId", 0);
        var res = await request({
          url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        });
        var temp = {};
        if (res.content.length > 0) {
          let newaddformTypeArr = [];
          res.content.forEach(item => {
            temp = {
              id: item.id,
              value: item.id,
              label: item.orgName,
              orgType: item.orgType
            };
            this.selectOrgs1.push(temp);
          });

          this.selectOrgs1 = this.selectOrgs1.filter(it => it.orgType == 1);
        }
      } else {
        //获取子组织
        fd.append("parentId", selVal);
        var res = await request({
          url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        });
        this.selectOrgs2 = [];
        var temp = {};
        if (res.content.length > 0) {
          this.allOrgs = res.content;
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName };
            this.selectOrgs2.push(temp);
          });
        }
      }
    },
    //获取召开地址列表
    async getAreas() {
      let fd = new FormData();
      fd.append("token", token);
      fd.append("pageNo", 1);
      fd.append("pageSize", 20);
      let params = JSON.stringify({ status: "0" });
      fd.append("findConsultAddress", params);
      var res = await request({
        url: "/admin/consulAddress/info/findConsultAddressList",
        method: "POST",
        data: fd
      });
      // console.log(res)
      this.selectAreas = [];
      if (res.code == 200 && res.content.count > 0) {
        res.content.list.forEach(item => {
          var temp = {
            value: item.id,
            label: item.province + item.city + item.area + item.detailed
          };
          this.selectAreas.push(temp);
        });
      }
    },
    mergeObject(data) {
      let result = data.reduce((result, item) => {
        let index = result.findIndex(
          v => v.parentPersonTypeId === item.parentPersonTypeId
        );
        let { parentPersonTypeId, parentPersonTypeName, ...single } = item;
        if (index === -1) {
          result.push({
            parentPersonTypeId,
            consultName: parentPersonTypeName,
            persionArr: [single]
          });
        } else {
          result[index].persionArr.push(single);
        }
        return result;
      }, []);
      //   console.log(result);
      return result;
    },
    getDataDetails() {
      console.log('getDataDetails')
      post("/admin/consult/info/findConsultById",{
        id: this.rowid
      }).then(res => {
        console.log(res)
        this.addform = res.content;
      })
    },
    async getData() {
      this.addform = {};
      this.tableData = [];
      this.tableData1 = [];
    },
    showPersonSelected(ind, type) {
      this.checkpeop = true;
      this.checkpeopFlag = ind;
      this.checkpeopData = this.addformTypeArr[ind]
        ? this.addformTypeArr[ind].persionArr
        : "";

      this.checkpeopData = this.checkpeopData.map(it => {
        if (it.personId) {
          it.id = it.personId;
        }
        return it;
      });
      console.log(this.addformTypeArr[ind]);

      this.checkpeopTypeData = this.addformTypeArr[ind]
        ? this.addformTypeArr[ind].parentPersonTypeId
        : "";
    },
    // 选择人员返回选中成员
    // choosePeopleFunc(val) {
    //   this.addformTypeArr[this.checkpeopFlag].persionArr = val;
    //   const tableName = "persionTable" + this.checkpeopFlag;
    //   if (this.$refs[tableName]) this.$refs[tableName][0].doLayout();

    //   this.checkpeop = false;
    //   this.checkpeopFlag = "";
    //   this.checkpeopData = [];
    //   this.checkpeopTypeData = "";
    // },
    // 添加人员返回选中成员
    choosePeopleFunc(val) {
      console.log(val)
      this.tableList = val;
      this.tableData1.push(this.tableList);
      console.log(this.tableData1)
      this.checkpeop = false;
    },
    // 选择人员类别返回选中成员
    choosePeopleTypeFunc(val) {
      this.tableData = [];
      this.addformTypeArr = [];
      console.log(val)
      this.checkpeopType = false;
      this.addformTypeArr.push(val);
      console.log(this.addformTypeArr)
      this.tableData = this.addformTypeArr[0].persionArr;
      console.log(this.tableData)
    },
    deletePeopleFunc(ind, rowId) {
      this.addformTypeArr[ind].persionArr = this.addformTypeArr[
        ind
      ].persionArr.filter(item => item.id !== rowId);
    },
    //利益人维护方法
    addTableRow(flag) {
      if (flag == "liyi") {
        this.numliyi++;
        this.addform.interestParty.push({
          id: this.numliyi,
          personType: 0,
          parentPersonTypeId: 7
        });
      } else if (flag == "other") {
        this.numOther++;
        this.addform.someoneElse.push({
          id: this.numOther,
          personType: 0,
          parentPersonTypeId: 7
        });
      }
    },
    delTableRow(rowId, flag) {
      console.log(rowId);

      // console.log(some)
      if (rowId != undefined) {
        if (flag == "liyi") {
          this.addform.interestParty = this.addform.interestParty.filter(
            item => item.id !== rowId
          );
        } else if (flag == "other") {
          this.addform.someoneElse = this.addform.someoneElse.filter(
            item => item.id !== rowId
          );
        }
      }
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      console.log(response);
      if (response.code == 200) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    saveadddata() {
      this.$refs.addform.validate(valid => {
        if (valid) {
          this.saveadddata2();
        } else {
          this.$message({
            message: "请输入正确信息",
            type: "error"
          });
          return false;
        }
      });
    },
    //获取新增所有数据发请求
    async saveadddata2() {
      let apidata = JSON.parse(JSON.stringify(this.addform));
      console.log('this.fileList',this.fileList)
      if (this.fileList.length > 0) {
        apidata.enclosurePath = "";
        apidata.enclosureName = "";
        this.fileList.forEach(item => {
          apidata.enclosurePath = apidata.enclosurePath + "," + item.url;
          apidata.enclosureName = apidata.enclosureName + "," + item.name;
        });
      }

      //去除空格栏
      let interestParty = [];
      apidata.interestParty.forEach(item => {
        if (item.name != "") {
          item.parentPersonTypeId = 7;
          item.personTypeId = null;
          delete item.id;
          interestParty.push(item);
        }
      });
      apidata.interestParty = interestParty;

      let someoneElse = [];
      apidata.someoneElse.forEach(item => {
        if (item.name != "") {
          item.parentPersonTypeId = 8;
          item.personTypeId = null;
          delete item.id;
          someoneElse.push(item);
        }
      });
      apidata.someoneElse = someoneElse;

      apidata.persons = [...interestParty, ...someoneElse];
      this.addformTypeArr.forEach(element => {
        let datas = element.persionArr.map(it => {
          if (!this.addform.id) {
            it.personId = it.id;
          }

          delete it.id;
          return it;
        });
        apidata.persons.push(...datas);
      });

      apidata.publishPlatform = apidata.publishPlatform.join(",");
      delete apidata.someoneElse;
      delete apidata.interestParty;

      let url = "/admin/consul/info/insertConsult";
      if (this.addform.id) {
        url = "/admin/consul/info/updateConsult";
      }

      var res = await request({
        url: url,
        method: "POST",
        data: apidata
      });

      if (res.code == 200) {
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.closeDialog();
      } else {
        this.addform.interestParty = [
          { id: 1, name: "", sex: "", numberId: "", phone: "" }
        ];
        this.addform.someoneElse = [
          { id: 1, name: "", sex: "", numberId: "", phone: "" }
        ];
        this.addform.publishPlatform = this.addform.publishPlatform
          ? this.addform.publishPlatform.split(",")
          : [];

        this.$message({
          message: "保存失败：" + res.message,
          type: "error"
        });
      }
    },
    closeDialog() {
      this.$emit("func", []);
      this.resetData();
    },
    resetData() {
      this.addform = {};
      this.addformTypeArr = [];
      this.$nextTick(() => {
        this.$refs.addform.clearValidate();
      });
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.resetData();
      }
    }
  },
  updated() {},
  mounted() {
    this.getFindConsultById();
    // console.log(this.id)
    this.getTypes("");
    this.getOrg("");
    this.getAreas();
    this.getFindConsultList();
    // this.getData()  //父组件调用时已启用此方法
  },
  beforeDestroy() {}
};
</script>
 
<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
  }
}

.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.el-input__inner {
  color: #606266 !important;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
  min-width: 1578px !important ;
}
.consulAddDialog {
  .line_box {
    align-items: center;
    border-bottom: 1px solid#ddd;
    padding-bottom: 10px;
    margin-top: 20px;
    color: #333;
    font-size: 15px;
    font-weight: 700;
  }
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
</style>